import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { readHandoff, saveHandoff, clearHandoff } from "../lib/handoff";

const redeemed = new Set();
const INVALID = "This sign-in link was already used or is invalid";
const GENERIC = "Couldn't sign in with Boat RV Moving right now. Please try again or sign in with email.";

const friendly = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : GENERIC;
};

export default function SsoCallback() {
  const { redeemSso } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const ticket = params.get("ticket");
    if (ticket && redeemed.has(ticket)) return;
    window.history.replaceState(null, "", "/auth/callback");
    const fail = (notice) => {
      toast.error(notice);
      navigate("/login", { replace: true, state: { notice } });
    };
    if (!ticket) return fail(INVALID);
    redeemed.add(ticket);
    const handoff = readHandoff(params);
    clearHandoff();
    redeemSso(ticket)
      .then(() => {
        saveHandoff(handoff);
        navigate("/", { replace: true });
      })
      .catch((e) => fail(friendly(e)));
  }, [params, navigate, redeemSso]);

  return (
    <div className="boot" data-testid="sso-callback">
      <div className="sso-wait"><span className="boot-dot" /><p>Signing you in with Boat RV Moving…</p></div>
    </div>
  );
}
